import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router";
import { astryx, neutralTheme, useDocumentTheme } from "@shadowcue/ui";
import Index from "../components/dashboard";
import Reports from "../components/dashboard/reports";
import Interviews from "../components/dashboard/conversations/index";
import ConversationSummary from "../components/dashboard/conversations/show";
import ConversationTranscript from "../components/dashboard/conversations/transcript";
import DownloadsPage from "../components/dashboard/product_download/DownloadsPage";
import SidebarLayout from "../components/shared/sidebar_layout";
import AdminRouteGuard from "./adminRouteGuard";
import adminRoutes from "./adminRoutes";
import { IUser } from "../types/iuser";

interface RouterProps {
  currentUser: IUser;
}

const DashboardRouter = (props: RouterProps) => {
  const mode = useDocumentTheme();

  return (
    <BrowserRouter>
      <astryx.LinkProvider component={Link}>
        <astryx.Theme theme={neutralTheme} mode={mode}>
          <astryx.LayerProvider>
            <SidebarLayout currentUser={props.currentUser}>
              <Routes>
                <Route path="/dashboard" element={<Index {...props} />} />
                <Route path="/dashboard/reports" element={<Reports {...props} />} />
                <Route
                  path="/dashboard/conversations"
                  element={<Interviews {...props} />}
                />
                <Route
                  path="/dashboard/conversations/:id"
                  element={<ConversationSummary {...props} />}
                />
                <Route
                  path="/dashboard/conversations/:id/transcript"
                  element={<ConversationTranscript {...props} />}
                />
                <Route
                    key="/dashboard/downloads"
                    path="/dashboard/downloads"
                    element={<DownloadsPage {...props} />}
                />
                <Route element={<AdminRouteGuard currentUser={props.currentUser} />}>
                  {adminRoutes(props)}
                </Route>
              </Routes>
            </SidebarLayout>
          </astryx.LayerProvider>
        </astryx.Theme>
      </astryx.LinkProvider>
    </BrowserRouter>
  );
};

export default DashboardRouter;
